import './advertising.scss';
import { ProgressBar } from '../advertising-progressbar/advertising-progressbar';

export class Advertising {
    constructor(target) {
        this.element = $(target);
        this.screen  = $(window).width() > 1024 ? 'desktop' : 'mobile';

        this.fullscreen        = this.element.hasClass('advertising--fullscreen');
        this.galleryFullscreen = this.element.hasClass('gallery-ad--fullscreen');
        this.expanding         = this.element.hasClass('advertising--expanding');
        this.mobileSiteHeader  = this.element.hasClass('advertising--siteheader-mobile');

        this.classes = {
            active: 'is-active',
            adDefault: 'advertising',
            adSupporter: 'advertising-supporter',
            sideAdFirst: 'advertising--side-second',
            adMiniMobile: 'advertising--mini-mobile',
            expanding: 'advertising--expanding',
            fullscreen: 'advertising--fullscreen',
            closeButton: 'advertising__close',
            main: 'is-main',
            initialized: 'is-initialized',
            loaded: 'is-loaded',
            fullscreenAdvertising: 'advertising--fullscreen',
            header: 'header',
            headerNav: 'header__nav',
        };

        this.closeButton = this.element.find(`.${this.classes.closeButton}`);
        this.header      = $(`.${this.classes.header}`);
        this.headerNav   = $(`.${this.classes.headerNav}`);

        this.adDesktop   = this.element.find('.advertising__desktop, .billboard-desktop');
        this.adDesktopId = this.adDesktop.attr('id') || '';
        this.adMobile    = this.element.find('.advertising__mobile, .billboard-mobile');
        this.adMobileId  = this.adMobile.attr('id') || '';

        this.adIds = `${this.adDesktopId}, ${this.adMobileId}`;

        this.init();
    }


    init() {
        this.closeButton.on('click', this.closeAd.bind(this));
    }

    closeAd() {
        this.element.closest(`.${this.classes.adDefault}`).remove();

        this.header.css('top', 'var(--wp-admin--admin-bar--height, 0px)');
    }

    addLoadedClass() {
        this.element.addClass(this.classes.loaded);
    }

    startProgressbar() {
        const progressbar = this.element.find('.js-advertising-progressbar');

        if (progressbar) {
            new ProgressBar(progressbar);
        }
    }

    remove() {
        this.element.remove();
    }
}

window.ballers.ads = [];

$(() => {
    $('.js-advertising').map(function() {
        window.ballers.ads.push(new Advertising(this));
    });
});

const advertisingSitehatHeightCalculation = () => {
    const sitehatHeight = $('.advertising--sitehat-aspect-ratio').innerHeight();

    document.documentElement.style.setProperty('--sitehat-height', `${sitehatHeight}px`);
};

$(() => {
    advertisingSitehatHeightCalculation();
});

// Simple debounce implementation using setTimeout
let advertisingSitehatResizeTimeout;

$(window).on('resize', () => {
    clearTimeout(advertisingSitehatResizeTimeout);
    advertisingSitehatResizeTimeout = setTimeout(advertisingSitehatHeightCalculation, 100);
});
